import { convenient } from '../gradation';
export default {
  gradation: convenient,
  flavour: ['long-convenient', 'long'],
  units: ['now', 'minute', 'hour', 'day', 'week', 'month', 'year']
};
//# sourceMappingURL=default.js.map